module.exports = __webpack_public_path__ + "img/35-Dry.4d93c1c0.png";